(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/router/assets/javascripts/marketplace-router.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/router/assets/javascripts/marketplace-router.js'); 
'use strict';

const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  TabsLoader,
  StartOverview
} = svs.marketplace.components.router;
const {
  lazy
} = svs.components.lbUtils.lazy;
const {
  baseUrl
} = svs.core.data;
const {
  matchPath,
  Route,
  Link
} = ReactRouterDOM;
const {
  useEffect
} = React;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const BrowseGames = lazy('/cl/marketplace/react:browse-games', () => svs.components.marketplace.browseGames.BrowseGames, {
  fallback: TabsLoader
});
const GameGuide = lazy('/cl/marketplace/react:game-guide', () => svs.components.marketplace.gameGuide.GameGuide, {
  fallback: TabsLoader
});
const UpToDate = lazy('/cl/marketplace/react:up-to-date', () => svs.components.marketplace.upToDate.UpToDate, {
  fallback: TabsLoader
});
const MarketplaceRouter = () => {
  useEffect(() => {
    svs.components.header.triggerOnHeaderVisibilityChange(true, ['xs', 'sm']);
    return () => {
      svs.components.header.triggerOnHeaderVisibilityChange(false, ['xs', 'sm']);
    };
  }, []);
  return React.createElement("div", {
    className: "marketplace-router"
  }, React.createElement(svs.app.ReactRouter.PlayerRouter, {
    basename: baseUrl,
    className: "qa-marketplace-player-router",
    render: _ref => {
      let {
        location
      } = _ref;
      const searchParams = new URLSearchParams(location.search);
      const arrivedFromBrowseGames = searchParams.get('origin') === '/hitta-andelsspel';
      const tabs = [{
        exact: false,
        component: StartOverview,
        path: '/',
        label: 'Dina lag och ombud',
        isActive: () => {
          const matchedTabs = tabs.filter(t => matchPath(location.pathname, {
            path: t.path
          }));
          return !arrivedFromBrowseGames && matchedTabs.length === 1;
        }
      }, {
        exact: false,
        path: '/hitta-andelsspel',
        label: 'Sök andelsspel',
        component: BrowseGames,
        isActive: match => match || arrivedFromBrowseGames
      }, {
        exact: false,
        path: '/spelguide',
        label: 'Spelguide',
        component: GameGuide
      }, {
        exact: false,
        path: '/aktuellt',
        label: 'Aktuellt',
        component: UpToDate
      }];
      if (svs.core.detect.feature('ft-marketplace-seperation')) {
        tabs.splice(1, 0, {
          exact: false,
          component: StartOverview,
          path: '/andelar',
          label: 'Andelar'
        });
      }
      const shouldShowNavbar = location.pathname === '/' || tabs.filter(t => matchPath(location.pathname, {
        path: t.path
      })).length === 2;
      return React.createElement(React.Fragment, null, tabs.length > 1 && shouldShowNavbar && React.createElement("div", {
        className: "tabs-marketplace-fixed"
      }, React.createElement(ItemsMenu, {
        branding: "sport",
        centered: true,
        className: "marketplace-routed-tabs  qa-marketplace-tabs-menu",
        hiddenScrollbar: true,
        useScrollFaders: true
      }, tabs.map(_ref2 => {
        let {
          label,
          path
        } = _ref2;
        return React.createElement(LinkItem, {
          Component: Link,
          id: "qa-".concat(label.toLowerCase().replace(/å|ä/, 'a').replace('ö', 'o')
          .replaceAll(/\s/g, '-')),
          key: path,
          label: label,
          selected: path === location.pathname,
          to: path
        });
      }))), React.createElement("div", {
        className: "".concat(shouldShowNavbar && 'marketplace-routed-content ' || '', "tabs-marketplace-fixed-content")
      }, React.createElement(ErrorBoundary, null, React.createElement(ReactRouterDOM.Switch, null, tabs.sort((a, b) => b.path.length - a.path.length).map(_ref3 => {
        let {
          exact,
          path,
          component
        } = _ref3;
        return React.createElement(Route, {
          component: component,
          exact: exact,
          key: path,
          path: path
        });
      })))));
    }
  }));
};
setGlobal('svs.marketplace.components.router.MarketplaceRouter', MarketplaceRouter);
 })(window);